import React, { useContext, useEffect, useState } from "react";
import { Router } from "@reach/router";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { AccountContext } from "./accountContext";
import StartPage from "./start";
import Photo from "./photo";
import CustomerInfo from "./customerInfo";
import Password from "./password";
import Ticket from "./registerTicket";
import SaleHistory from "./saleHistory";
import RegisterManaged from "./registerManagedParty";
import Subscription from "./subscription";
import SubscriptionDetails from "./subscription/SubscriptionDetails";
// import Breadcrumb from "../Common/breadcrumb";

const useStyles = makeStyles((theme) => ({
  account: {
    maxWidth: "1024px",
    width: "100%",
    padding: "1rem",
    margin: "0 auto",
    "@media(max-width: 1024px)": {
      padding: "1rem 1rem",
    },
  },
}));

const Content = () => {
  const classes = useStyles();
  const [hasSubcription, setHasSubscription] = useState(false);
  const { state } = useContext(AccountContext);

  useEffect(() => {
    if (state.accountData?.member.subscriptionHistory) {
      setHasSubscription(true);
    }
  }, [state.accountData]);

  return (
    <div className={classNames(classes.account, "account__container")}>
      {state.activePerson.id && (
        <div className={classes.paper}>
          {/* <Breadcrumb /> */}
          <Router primary={false}>
            <StartPage path={`/`} />
            <CustomerInfo path={`/customer-info`} />
            <Photo path={`/photo`} />
            <Password path={`/password`} />
            <Ticket path={`/register-ticket`} />
            <RegisterManaged path={`/register-managed`} />
            <SaleHistory path={`/sale-history`} />
            {hasSubcription && <Subscription path={`/subscription`} />}
            {hasSubcription && (
              <SubscriptionDetails path={`/subscription/:id`} />
            )}
          </Router>
        </div>
      )}
    </div>
  );
};

export default Content;
